import { lastRecommendedVersionLocalStorageKey } from './constants'

export const getMostRecentVersion = (version1: string, version2: string): string => {
  const comparison = version1.localeCompare(version2, undefined, { numeric: true })
  return comparison > -1 ? version1 : version2
}

export const saveToLocalStorage = (version: string) => {
  localStorage.setItem(lastRecommendedVersionLocalStorageKey, version)
}
